export default __webpack_public_path__ + "static/media/Dark Cybernetic World.2c17b124.mp3";